// collection-handle-filter.js — Versteckt Produkt-Cards auf Collection-Seiten
// basierend auf dem URL-Parameter `handles`. Wird vom Cascade-Resolver gesetzt:
//   /collections/<handle>?handles=k1:XS,k2:XS,k3:XS&marke=…&modell=…&baujahr=…
//
// Die Werte in `handles` sind seit dem Key-Redesign STABILE fitment_keys
// (z.B. perfect_stretch), NICHT Produkt-Handles. Gematcht wird gegen
// card.dataset.fitmentKey (= product.metafields.custom.fitment_key). Der
// Param-Name bleibt `handles` aus Kompatibilitätsgründen (Sticky-Facets).
//
// Encoding: key:size  (size optional, kein ":" → kein size-Hint)
// Wenn `handles` nicht gesetzt ist, werden alle Cards sichtbar gemacht (Reset).
//
// Side-Effects:
//   1. Nur Cards mit data-product-handle in der Liste bleiben sichtbar
//   2. Card-Hrefs werden mit ?size=… (+ marke/modell/baujahr) angereichert,
//      damit variant-lock.js auf der PDP die richtige Variante vorselektiert

(function () {
  const CASCADE_LINK_PARAMS = ['size', 'marke', 'modell', 'reihe', 'baujahr'];

  function parseHandleSpec(handlesRaw) {
    const map = new Map();
    handlesRaw.split(',').map(s => s.trim()).filter(Boolean).forEach(item => {
      const idx = item.indexOf(':');
      if (idx > 0) {
        map.set(item.slice(0, idx), item.slice(idx + 1));
      } else {
        map.set(item, '');
      }
    });
    return map;
  }

  function decorateCardHref(card, size, marke, modell, baujahr) {
    // Alle <a>-Tags innerhalb der Card, die auf eine Produktseite zeigen
    const links = card.querySelectorAll('a[href*="/products/"]');
    links.forEach(link => {
      try {
        const url = new URL(link.getAttribute('href'), window.location.origin);
        CASCADE_LINK_PARAMS.forEach(k => url.searchParams.delete(k));
        // Serverseitige S-Vorauswahl (?variant=, Ab-Preis-Referenz) weicht dem
        // Fahrzeug-size-Hint — sonst überstimmt sie die passende Größe des Kunden.
        if (size) url.searchParams.delete('variant');
        if (size) url.searchParams.set('size', size);
        if (marke) url.searchParams.set('marke', marke);
        if (modell) url.searchParams.set('modell', modell);
        if (baujahr) url.searchParams.set('baujahr', baujahr);
        const nextHref = url.pathname + (url.search ? url.search : '');
        if (link.getAttribute('href') !== nextHref) {
          link.setAttribute('href', nextHref);
        }
      } catch (_) { /* ignore malformed urls */ }
    });
  }

  function decorateCtx(url, ctx) {
    try {
      const u = new URL(url, window.location.origin);
      if (ctx.size) u.searchParams.set('size', ctx.size);
      if (ctx.marke) u.searchParams.set('marke', ctx.marke);
      if (ctx.modell) u.searchParams.set('modell', ctx.modell);
      if (ctx.baujahr) u.searchParams.set('baujahr', ctx.baujahr);
      return u.pathname + (u.search || '');
    } catch (_) { return url; }
  }

  // Liest den Steuer-Suffix (z.B. "inkl. MwSt.") aus der Basis-.price-DOM, damit
  // die neu gebaute Ghost-Preis-DOM ihn übernimmt. Der "Ab"/"Von"-Range-Präfix
  // wird bewusst übersprungen — Ghost-Cards zeigen einen exakten Preis.
  function extractTaxSuffix(priceEl) {
    if (!priceEl || !priceEl.querySelectorAll) return '';
    const sups = priceEl.querySelectorAll('.sup');
    for (let i = 0; i < sups.length; i++) {
      const t = String(sups[i].textContent || '').trim();
      if (t && t !== 'Ab' && t !== 'Von') return ' <span class="sup">' + t + '</span>';
    }
    return '';
  }

  function applyVariantPrice(clone, card) {
    const builder = window.CECVariantCards;
    if (!builder || typeof builder.priceHtml !== 'function') return;
    const priceEl = clone.querySelector('.price');
    if (!priceEl) return;
    const onSale = card.compareAt != null && Number(card.compareAt) > Number(card.price);
    const cls = String(priceEl.className || '').split(/\s+/)
      .filter(t => t && t !== 'price-on-sale' && t !== 'price-sold-out');
    if (onSale) cls.push('price-on-sale');
    priceEl.className = cls.join(' ');
    priceEl.innerHTML = builder.priceHtml(card, extractTaxSuffix(priceEl));
  }

  // Patcht den Stock-Badge (.badge-stock) auf die Verfügbarkeit DIESER Variante —
  // sonst zeigt die Ghost-Card weiter die serverseitige Produkt-Level-Verfügbarkeit
  // (irgendeine Variante lagernd), auch wenn genau die gesuchte Größe ausverkauft ist.
  function applyVariantStock(clone, card) {
    const builder = window.CECVariantCards;
    if (!builder || typeof builder.applyVariantStock !== 'function') return;
    builder.applyVariantStock(clone, card);
  }

  function renderVariantCards(baseCard, wrapper, cards, ctx) {
    const parent = wrapper.parentNode;
    if (parent && parent.querySelectorAll) {
      parent.querySelectorAll('[data-cec-ghost="' + baseCard.dataset.productHandle + '"]')
        .forEach(n => n.remove());
    }
    if (!cards.length) { wrapper.style.display = 'none'; return; }
    wrapper.style.display = 'none';
    cards.forEach(card => {
      const clone = wrapper.cloneNode(true);
      clone.style.display = '';
      clone.dataset.cecGhost = baseCard.dataset.productHandle;
      const img = clone.querySelector('img.card-media-image');
      if (img && card.image) { img.setAttribute('src', card.image); img.removeAttribute('srcset'); }
      applyVariantPrice(clone, card);
      applyVariantStock(clone, card);
      if (card.isOpened) {
        const doc = clone.ownerDocument || document;
        // Badge gehört in den absolut über dem Media positionierten
        // .card-product-badges-Container. Den rendert card-product.liquid nur,
        // wenn das Produkt sichtbare Badges hat → ggf. selbst anlegen, sonst
        // fällt der Badge ans Card-Ende (unter die Kachel).
        let badgesWrap = clone.querySelector('.card-product-badges');
        if (!badgesWrap) {
          badgesWrap = doc.createElement('div');
          badgesWrap.className = 'card-product-badges';
          const cardEl = clone.querySelector('[data-product-handle]') || clone;
          const ref = cardEl.children && cardEl.children[0];
          if (cardEl.insertBefore) cardEl.insertBefore(badgesWrap, ref || null);
          else cardEl.appendChild(badgesWrap);
        }
        const badge = doc.createElement('div');
        badge.className = 'card-badge';
        const pill = doc.createElement('span');
        pill.className = 'badge badge-opened';
        pill.textContent = card.label;
        badge.appendChild(pill);
        badgesWrap.appendChild(badge);
      }
      clone.querySelectorAll('a[href*="/products/"]').forEach(a => {
        if (card.url) a.setAttribute('href', decorateCtx(card.url, ctx));
      });
      if (parent) parent.insertBefore(clone, wrapper.nextSibling);
    });
  }

  // Shared helper: render only "Geöffnete Verpackung" ghost-cards for every
  // [data-product-handle] card on the page (used by both the angebote branch
  // and the sonderpreis-only branch).
  // Sammelt die aktiven Farb-Facetten-Werte. Shopify benennt Options-Facetten
  // `filter.v.option.<option>` (lowercased) → hier `filter.v.option.farbe`.
  // Tolerant: jeder Param-Key, der (case-insensitiv) auf ".farbe" endet.
  function selectedColors(params) {
    const out = [];
    for (const [k, v] of params.entries()) {
      if (/\.farbe$/.test(k.toLowerCase()) && v) out.push(v);
    }
    return out;
  }

  function renderOpenedOnlyAcrossCards(cards, colors) {
    const ctx = {};
    cards.forEach(c => {
      const wrapper = c.closest('li, .grid-item, .col, .product-list__item') || c;
      const builder = window.CECVariantCards;
      const dataEl = c.querySelector('script.cec-variant-data');
      if (builder && dataEl) {
        let variants = [];
        try { variants = JSON.parse(dataEl.textContent || '[]'); } catch (_) {}
        let vcards = builder.buildVariantCards(variants, {});
        vcards = builder.filterSonderpreis(vcards, true);
        if (builder.filterColors) vcards = builder.filterColors(vcards, colors);
        renderVariantCards(c, wrapper, vcards, ctx);
      } else {
        wrapper.style.display = 'none';
      }
    });
  }

  function apply() {
    const params = new URLSearchParams(window.location.search);
    const handlesRaw = params.get('handles');
    const onlyOpened = params.get('sonderpreis') === '1';
    // Alte Ghost-Klone global abräumen — BEVOR wir die Karten einsammeln, sonst
    // landen Klone vom letzten Lauf in `cards` (fixt Dubletten beim Abwählen des
    // Sonderpreis-Hakens / Reset). renderVariantCards baut sie bei Bedarf neu.
    document.querySelectorAll('[data-cec-ghost]').forEach(n => n.remove());
    // Dublette Original-Cards (gleiche product-id) entfernen. Auf derselben
    // Collection (/collections/autoabdeckung) koexistieren zwei Filtersysteme;
    // ein erneuter Cascade-Submit (same-path) bzw. Multi-Page-Nachladen kann
    // dieselbe Produkt-Kachel mehrfach in den Grid hängen. Ghosts sind oben
    // schon weg → hier nur echte Originale deduplizieren, sonst zählt der Banner
    // doppelt und dieselbe Kachel erscheint mehrfach.
    const seenPid = new Set();
    document.querySelectorAll('[data-product-handle]').forEach(c => {
      const pid = c.dataset.productId;
      if (!pid) return;
      if (seenPid.has(pid)) {
        (c.closest('li, .grid-item, .col, .product-list__item') || c).remove();
      } else {
        seenPid.add(pid);
      }
    });
    const cards = document.querySelectorAll('[data-product-handle]');
    const colors = selectedColors(params);

    // Eventuelle Vor-Revision-Banner außerhalb des Grids abräumen
    document.querySelectorAll('#cascade-results-banner').forEach(n => {
      // nur die löschen, die NICHT im aktuellen Insertion-Point sitzen
      if (!n.dataset.cecInGrid) n.remove();
    });

    if (!handlesRaw) {
      // Angebote-Modus: nur geöffnete Verpackung ghost-cards rendern
      const gridContainer = document.getElementById('ProductGridContainer');
      if (gridContainer && gridContainer.dataset.collectionHandle === 'angebote') {
        renderOpenedOnlyAcrossCards(cards, colors);
        return;
      }
      // Sonderpreis-Checkbox aktiv (beliebige Collection): nur Produkte MIT
      // verfügbarer "Geöffnete Verpackung"-Variante zeigen.
      if (onlyOpened) {
        renderOpenedOnlyAcrossCards(cards, colors);
        return;
      }
      // Reset: alle Cards wieder sichtbar machen, Banner entfernen
      cards.forEach(c => {
        const wrapper = c.closest('li, .grid-item, .col, .product-list__item') || c;
        wrapper.style.display = '';
      });
      removeBanner();
      return;
    }

    const handleMap = parseHandleSpec(handlesRaw);
    if (handleMap.size === 0) return;

    const marke = params.get('marke') || '';
    const modell = params.get('modell') || '';
    const baujahr = params.get('baujahr') || '';
    const globalSize = params.get('size') || '';

    let visible = 0;
    cards.forEach(c => {
      // Match per STABILEM fitment_key (data-fitment-key), nicht per Produkt-Handle.
      // Der Handle hängt am Titel (Veronika kann ihn ändern) und brach so das
      // Matching nach Produkt-Umbenennungen. Fallback auf den Handle nur für
      // Alt-Links/Nicht-Cover-Karten.
      const h = c.dataset.fitmentKey || c.dataset.productHandle;
      const wrapper = c.closest('li, .grid-item, .col, .product-list__item') || c;
      if (handleMap.has(h)) {
        const sizeForCard = handleMap.get(h) || globalSize;
        const builder = window.CECVariantCards;
        const dataEl = c.querySelector('script.cec-variant-data');
        if (builder && dataEl) {
          let variants = [];
          try { variants = JSON.parse(dataEl.textContent || '[]'); } catch (_) {}
          let vcards = builder.buildVariantCards(variants, { size: sizeForCard });
          vcards = builder.filterSonderpreis(vcards, params.get('sonderpreis') === '1');
          if (builder.filterColors) vcards = builder.filterColors(vcards, colors);
          // sizeForCard wandert mit in den Ctx, damit der Ghost-Card-Link
          // ?size=… trägt → variant-lock.js zeigt auf der PDP den grünen Hinweis
          // („passende Größe vorgewählt"). Der Angebote-/Sonderpreis-Pfad ruft
          // renderVariantCards mit leerem Ctx (kein Fahrzeug) → kein size, kein Lock.
          renderVariantCards(c, wrapper, vcards, { marke, modell, baujahr, size: sizeForCard });
        } else {
          wrapper.style.display = '';
          decorateCardHref(c, sizeForCard, marke, modell, baujahr);
        }
        visible++;
      } else {
        wrapper.style.display = 'none';
      }
    });

    renderBanner(marke, modell, baujahr, visible);
  }

  function removeBanner() {
    document.getElementById('cascade-results-banner')?.remove();
  }

  function renderBanner(marke, modell, baujahr, visible) {
    const parts = [marke, modell, baujahr].filter(Boolean);
    const label = parts.join(' · ');

    let host = document.getElementById('cascade-results-banner');
    if (!host) {
      host = document.createElement('div');
      host.id = 'cascade-results-banner';
      host.className = 'cascade-results-banner';
      host.dataset.cecInGrid = '1';

      // Insertion: INNERHALB des Collection-Content-Blocks, direkt vor dem Grid.
      // → sitzt visuell in derselben Spalte wie die Cards (nicht full-width).
      const grid = document.getElementById('product-grid');
      const collectionWrap = grid?.closest('.collection') || grid?.parentNode;
      if (grid && collectionWrap) {
        collectionWrap.insertBefore(host, grid);
      } else {
        // Fallback: vor dem Section-Wrapper
        const gridSection =
          document.querySelector('[id*="main-collection-product-grid"]') ||
          document.querySelector('.section-main-collection-product-grid');
        if (gridSection && gridSection.parentNode) {
          gridSection.parentNode.insertBefore(host, gridSection);
        } else {
          document.body.prepend(host);
        }
      }
    }

    // Strings aus window.cecLocale (gefüllt in sections/filters.liquid). Die
    // Pluralform steckt in der Übersetzung, nicht im JS: "1 Produkt" / "3 Produkte"
    // folgt anderen Regeln als "1 product" / "3 products".
    const countKey = visible === 1 ? 'cascade_results_count_one' : 'cascade_results_count_many';
    const countFallback = visible === 1 ? '{{ count }} Produkt gefunden' : '{{ count }} Produkte gefunden';
    const countText = t(countKey, countFallback).replace(/\{\{\s*count\s*\}\}/g, String(visible));

    const nextHtml =
      '<div class="cascade-results-banner__inner">' +
        '<div class="cascade-results-banner__text">' +
          '<strong>' + escapeHtml(t('cascade_results_label', 'Ergebnis:')) + '</strong> ' +
          escapeHtml(label || t('cascade_results_fallback', 'Suche')) + ' — ' +
          '<span>' + escapeHtml(countText) + '</span>' +
        '</div>' +
      '</div>';
    if (host.innerHTML !== nextHtml) {
      host.innerHTML = nextHtml;
    }
  }

  // Wie getLocale() in cascade-resolver.js: window.cecLocale wird in
  // sections/filters.liquid aus den Locale-Keys befüllt. Fehlt es (z.B. auf einer
  // Seite ohne Filter-Section), bleibt der deutsche Fallback.
  function t(key, fallback) {
    return (typeof window !== 'undefined' && window.cecLocale && window.cecLocale[key]) || fallback;
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, c => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[c]));
  }

  // Für same-path SPA-Submit (siehe cascade-resolver.js)
  window.__cecApplyHandleFilter = apply;

  // Cascade-Params, die wir über Facet-Submits hinweg festhalten müssen.
  // Shopifys FacetFiltersForm.mergePersistentParams behält nur `q` und
  // `options[prefix]` — alles andere fliegt beim ersten Filter raus.
  const STICKY = ['handles', 'size', 'marke', 'modell', 'reihe', 'baujahr'];
  let facetsPatchScheduled = false;

  function getFacetFiltersFormCtor() {
    // facets.js setzt die Klasse NICHT auf window, nur via customElements.define.
    if (typeof window.FacetFiltersForm === 'function') return window.FacetFiltersForm;
    return (window.customElements || customElements)?.get?.('facet-filters-form') ?? null;
  }

  function patchFacetsPersistentParams() {
    const FF = getFacetFiltersFormCtor();
    if (typeof FF !== 'function') return false;
    if (FF.__cecMergePatched) return true;
    const orig = FF.mergePersistentParams;
    if (typeof orig !== 'function') return false;
    FF.mergePersistentParams = function (sp) {
      const merged = new URLSearchParams(orig.call(this, sp));
      const current = new URLSearchParams(window.location.search);
      STICKY.forEach(k => {
        if (!merged.has(k) && current.has(k)) merged.set(k, current.get(k));
      });
      return merged.toString();
    };
    FF.__cecMergePatched = true;
    return true;
  }

  function scheduleFacetsPatch() {
    if (patchFacetsPersistentParams()) return;
    if (facetsPatchScheduled) return;
    facetsPatchScheduled = true;
    customElements.whenDefined('facet-filters-form').then(() => {
      facetsPatchScheduled = false;
      patchFacetsPersistentParams();
    });
  }

  function observeGridSwaps() {
    // Shopifys facets.js ersetzt `#ProductGridContainer.innerHTML` nach einem
    // Filter-Submit. Unsere display:none-Flags auf den Cards gehen dabei verloren.
    // → Bei jedem Top-Level-Child-Wechsel apply() neu laufen lassen.
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;
    const obs = new MutationObserver(() => apply());
    obs.observe(container, { childList: true });
  }

  function boot() {
    apply();
    scheduleFacetsPatch();
    observeGridSwaps();

    const cb = document.getElementById('cec-sonderpreis');
    if (cb) cb.addEventListener('change', () => {
      const u = new URL(window.location.href);
      if (cb.checked) u.searchParams.set('sonderpreis', '1');
      else u.searchParams.delete('sonderpreis');
      history.replaceState({}, '', u.pathname + (u.search || ''));
      apply();
    });
  }

  // Sofort versuchen (für den Fall, dass facets.js schon parsed ist), und
  // nochmals in boot() (DOMContentLoaded-Pfad) — zusammen mit whenDefined
  // sind alle Reihenfolge-Permutationen abgedeckt.
  scheduleFacetsPatch();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', apply);
})();
